export default "__VITE_ASSET__Be3UE5xL__"